export type SkeletonRectProps = {
    className?: string
}

export default function SkeletonRect(
    {className = ""}: SkeletonRectProps
): JSX.Element {
    return <div
        className={className + " animate-pulse bg-dark-alternating box-shadow-subtle"}
    />
}